import axios from "axios";
import appConfig from "../config/applicationConfiguration";
import {useEffect} from "react";
import {useNotification} from "../hooks/useNotification";
import NotificationModal from "../components/NotificationModal/NotificationModal";
import {closeIcon} from "../components/Icon/Icon";

export const SetupAxios = () => {
    const {triggerNotification, handleCloseNotification, notification} = useNotification();

    useEffect(() => {
        axios.defaults.baseURL = appConfig.apiUrl;
        axios.defaults.headers['Accept'] = 'application/json';


        axios.interceptors.request.use(
            config => {
                const token = localStorage.getItem("token");
                if(token){
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        )

        axios.interceptors.response.use(response => response, error => {
            if (error.response && error.response.status === 401 && error.response.data === "TOKEN_EXPIRED\n") {
                localStorage.clear();
                if(window.location.pathname !== "/") window.location.href = "/";
                return new Promise(() => {});
            }

            if(error.response && error.response.data != null){
                triggerNotification(error.response.data?.message ?? "Unknown error", 'error')
            }

            return Promise.reject(error);
        });
    }, [])

    return <>
        <NotificationModal
            isOpen={notification.isOpen}
            onClose={handleCloseNotification}
            message={notification.message}
            icon={closeIcon}
            type={notification.type}
        />
    </>
}

export default SetupAxios;